<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator=">">
      <el-breadcrumb-item>Active Report</el-breadcrumb-item>
      <el-breadcrumb-item>活跃报告</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <div class="container">
      <div style=" margin-right: 80px; "> </div>

      <div style="margin-bottom: 20px; margin-right: 20px; " size="medium">

        <el-radio-group v-model="radioFilter" style="margin-right: 20px; " size="medium">
          <el-radio-button label="indoor">室内全部</el-radio-button>
          <el-radio-button label="strict">有效骑行</el-radio-button>
        </el-radio-group>

        <el-radio-group v-model="radioCycle" style="margin-right: 20px; " size="medium">
          <el-radio-button label="weekly">weekly</el-radio-button>
          <el-radio-button label="monthly">monthly</el-radio-button>
        </el-radio-group>

        <el-radio-group v-model="radioType" style="margin-right: 20px; " size="medium">
          <el-radio-button label="pad">pad</el-radio-button>
          <el-radio-button label="app">app</el-radio-button>
          <el-radio-button label="all">all</el-radio-button>
          <el-radio-button label="xbike">xbike</el-radio-button>
          <el-radio-button label="litbike">litbike</el-radio-button>
          <el-radio-button label="boombike">boombike</el-radio-button>
          <el-radio-button label="boombasic">boombasic</el-radio-button>
          <el-radio-button label="ebike">ebike</el-radio-button>
        </el-radio-group>
        <el-button type="primary" @click="exportCsv" style="margin-left: 80px;">下载CSV</el-button>

      </div>
    </div>

    <!-- ECharts 容器 -->
    <div id="chart" style="height:400px; width:90%;   "></div>


    <el-table :data="tableData" stripe style="width: 100%" height="950"
      :default-sort="{ prop: 'title', order: 'descending' }">

      <el-table-column prop="title" label="日期" width="180" sortable>
      </el-table-column>
      <el-table-column prop="activate_count" label="激活设备">
      </el-table-column>

      <el-table-column prop="trialed_count" label="试用设备">
      </el-table-column>
      <el-table-column prop="subs_count" label="付费设备">
      </el-table-column>

      <el-table-column prop="subs_rate" label="付费设备占比">
      </el-table-column>

      <el-table-column prop="active_count" label="活跃设备数">
      </el-table-column>
      <el-table-column prop="active_old" label="活跃老设备">
      </el-table-column>
      <el-table-column prop="active_new" label="活跃新设备">
      </el-table-column>

      <el-table-column prop="active_subs" label="付费中活跃设备">
      </el-table-column>


      <el-table-column prop="active_activate_rate" label="激活活跃率">
      </el-table-column>
      <el-table-column prop="active_subs_rate" label="付费活跃率">
      </el-table-column>


      <el-table-column prop="action_total" label="总活跃次数">
      </el-table-column>
      <el-table-column prop="duration_total" label="活跃总时长">
      </el-table-column>


      <el-table-column prop="avg_action_count" label="台均活跃次数">
      </el-table-column>
      <el-table-column prop="avg_action_duration" label="台均活跃分钟">
      </el-table-column>

      <el-table-column prop="action_total_subs" label="付费活跃次数">
      </el-table-column>
      <el-table-column prop="duration_total_subs" label="付费活跃时长">
      </el-table-column>


      <el-table-column prop="avg_action_count_subs" label="付费台均活跃次">
      </el-table-column>
      <el-table-column prop="avg_action_duration_subs" label="付费台均活跃分钟">
      </el-table-column>

      <el-table-column prop="score_total" label="总得分" width="120">
      </el-table-column>

      <el-table-column prop="avg_score" label="平均得分">
      </el-table-column>



      <el-table-column prop="avg_onbeat" label="平均onbeat">
      </el-table-column>
      <el-table-column prop="avg_resistance" label="平均阻力">
      </el-table-column>



    </el-table>




  </div>
</template>

<script>
import { exportToCsv } from '@/utils/exportToCsv';


export default {
  data() {
    return {
      tableData: [],
      radioFilter: 'strict',
      radioCycle: 'weekly',
      radioType: 'pad',
      dates: [],
      active_activate_rate: [],
      active_subs_rate: [],
      active_activate_rate_yoy: [],
      active_subs_rate_yoy: []
    }
  },
  // 在 Vue 实例或组件中定义过滤器
  //不知道为什么 现在还没法用, 持续看看吧
  filters: {
    formatDecimal(value) {
      return parseFloat(value).toFixed(2);
    }
  },
  watch: {
    $route(newVal, oldVal) {
      this.getData(this.radioCycle, this.radioType, this.radioFilter)
    },

    radioCycle(newVal, oldVal) {
      this.radioCycle = newVal
      this.getData(this.radioCycle, this.radioType, this.radioFilter)
    },

    radioType(newVal, oldVal) {
      this.radioType = newVal
      this.getData(this.radioCycle, this.radioType, this.radioFilter)
    },
    radioFilter(newVal, oldVal) {
      this.radioFilter = newVal
      this.getData(this.radioCycle, this.radioType, this.radioFilter)
    },
  },
  created: function () {
    //注意回调函数的作用域!!!
  },

  methods: {
    formatDecimal(value) {
      return parseFloat(value).toFixed(2);
    },
    exportCsv() {
      let fileName = "activeReport_" + this.radioType + "_" + this.radioCycle
      exportToCsv(this.tableData, fileName)
    },


    async getData(cycle, bikeType, filter) {

      this.tableData = []
      let res = await this.$http.get("/da/active_report/" + cycle + "/" + bikeType + "/" + filter)  //activityWeekly
      this.tableData = res.data
      this.getLoadEcharts();
    },



    getLoadEcharts() {
      this.dates = []
      this.active_activate_rate = []
      this.active_subs_rate = []
      this.active_activate_rate_yoy = []
      this.active_subs_rate_yoy = []
      let dataLength = 80;
      let N = 12; // 假设N值为12
      if (this.radioCycle == "weekly") {
        N = 52
      }
      console.log(this.radioCycle)
      //  console.log("created() ==>   完毕", N)
      //  如果数据量不足52个，使用tableData的实际长度
      if (this.tableData.length < dataLength) {
        dataLength = this.tableData.length;
   
      }
    //  console.log("dataLength", dataLength)
    //  console.log("this.tableData.length", this.tableData.length)
      //循环i=0, - dataLength
      for (let i = 0; i < dataLength; i++) {
        console.log("i = ==dataLength", i)
        let index1 = this.tableData.length - dataLength + i;
        let index2 = this.tableData.length - dataLength + i - N;
        console.log("index1,index2", index1, index2)
        //先一定有的值
        this.dates[i] = this.tableData[index1].title;
        // 如果active_activate_rate是"-"，则将结果设置为0
        this.active_activate_rate[i] = this.tableData[index1].active_activate_rate.replace('%', '');
        this.active_subs_rate[i] = this.tableData[index1].active_subs_rate.replace('%', '');

        //然后往前追溯的值
        if (index2 < 0) {
          this.active_activate_rate_yoy[i] = 0;
          this.active_subs_rate_yoy[i] = 0;
        } else {
          // 如果active_activate_rate是"-"，则将结果设置为0
          let value1 = this.tableData[index2].active_activate_rate;
          if  (value1 == '-'){
            this.active_activate_rate_yoy[i]
          }else{ this.active_activate_rate_yoy[i] =  parseFloat(value1.replace('%', '')) ; }
           let value2 = this.tableData[index2].active_subs_rate;
           if  (value2 == '-'){
            this.active_subs_rate_yoy[i]=0
          }else{ this.active_subs_rate_yoy[i] =  parseFloat(value2.replace('%', '')) ; }
        }
      }

      // 确保ECharts实例存在，这里的 'chart' 应与你在模板中定义的元素ID匹配
      if (!this.chartInstance) {
        this.chartInstance = this.$echarts.init(document.getElementById('chart'));
      }
      // 配置ECharts的选项
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        title: {
    text: '活跃率对比图', // 标题文本
    left: 'left' // 标题的位置，这里设置为居中
  },

        legend: {
          data: ['激活活跃率', '激活活跃率去年','付费活跃率',  '付费活跃率去年']
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: this.dates // 使用this访问dates属性
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],

        series: [
          {
            name: '激活活跃率',
            type: 'line',
            // stack: '总量', // 如果不需要堆叠效果，可以移除stack属性
            //  areaStyle: {},
            data: this.active_activate_rate // 使用this访问active_activate_rate属性
          },
          {
            name: '激活活跃率去年',
            type: 'line',
            data: this.active_activate_rate_yoy // 使用this访问active_activate_rate_yoy属性
          },

          {
            name: '付费活跃率',
            type: 'line',
            // stack: '总量', // 如果不需要堆叠效果，可以移除stack属性
            //  areaStyle: {},
            data: this.active_subs_rate // 使用this访问active_subs_rate属性
          },

          {
            name: '付费活跃率去年',
            type: 'line',
            data: this.active_subs_rate_yoy // 使用this访问active_subs_rate_yoy属性
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      this.chartInstance.setOption(option);
    },
  },




  mounted: function () {
    //注意回调函数的作用域!!!
    this.getData(this.radioCycle, this.radioType, this.radioFilter)
  }



}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  display: flex;
  justify-content: flex-end;
}
</style>